<template>
    <div class="ajustes-detail-container">
        <!-- Estado de carga -->
        <div v-if="isLoading" class="text-center py-5">
            <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem;"
            ></b-spinner>
            <p class="mt-2 text-muted">
                {{ internalLabels.loading || 'Cargando...' }}
            </p>
        </div>

        <!-- Tabla de ajustes destino con CorporateDataTable -->
        <div v-if="!isLoading" class="ajustes-detail-table-container">
            <CorporateDataTable
                :items="ajustDestino || []"
                :fields="tableFields"
                :labels="tableLabels"
                :default-per-page="defaultPerPage"
                :page-options="pageOptions"
                :narrow="false"
                :table-min-height="490"
                :table-max-height="490"
                :show-search="true"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :filter-defs="tableFilterDefs"
                :toolbar-disabled="false"
                :show-back-button="showBackButton"
                :back-button-text="internalLabels.volver || 'Volver'"
                @back="goBack"
                class="ajustes-detail-table"
            >
                <template #toolbar-actions>
                    <div class="detail-toolbar-left d-flex align-items-center">
                        <!-- ESPACIO VACÍO - SIN TÍTULO -->
                    </div>

                    <div class="detail-toolbar-right d-flex align-items-center">
                        <b-button
                            size="sm"
                            class="table-toolbar-add-btn table-toolbar-add-btn-dest"
                            @click="adicionaCuentasDestino()"
                            :disabled="readOnly || !id_compania"
                        >
                            {{ internalLabels.adicionarCuenta || 'Adición Cuenta' }}
                        </b-button>

                        <b-button
                            size="sm"
                            class="table-toolbar-add-btn table-toolbar-add-btn-dest-new ml-2"
                            @click="adicionaCuentaNueva()"
                            :disabled="readOnly || !id_compania"
                        >
                            {{ internalLabels.adicionarCuentaNueva || 'Adición Cuenta Nueva' }}
                        </b-button>
                    </div>
                </template>

                <template #empty-state>
                    <div class="text-center py-5">
                        <font-awesome-icon
                            :icon="['fas', 'file-alt']"
                            size="4x"
                            class="text-muted mb-3"
                            style="opacity: 0.3;"
                        />
                        <p class="h5 text-muted">
                            {{ internalLabels.noData || 'No hay cuentas de destino registradas' }}
                        </p>
                        <div class="mt-3">
                            <b-button
                                variant="outline-primary"
                                size="sm"
                                @click="adicionaCuentasDestino()"
                                :disabled="readOnly || !id_compania"
                            >
                                <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />
                                {{ internalLabels.adicionarCuenta || 'Adición Cuenta' }}
                            </b-button>
                            <b-button
                                variant="primary"
                                size="sm"
                                class="ml-2"
                                @click="adicionaCuentaNueva()"
                                :disabled="readOnly || !id_compania"
                            >
                                <font-awesome-icon :icon="['fas', 'plus-square']" class="mr-1" />
                                {{ internalLabels.adicionarCuentaNueva || 'Adición Cuenta Nueva' }}
                            </b-button>
                        </div>
                    </div>
                </template>

                <!-- Columna Cuenta -->
                <template #cell(cuenta)="data">
                    <div class="text-left font-weight-bold">
                        {{ data.value }}
                    </div>
                </template>

                <!-- Columna Descripción -->
                <template #cell(descripcion)="data">
                    <div class="text-left">
                        {{ data.value }}
                    </div>
                </template>

                <!-- Columna Valor -->
                <template #cell(valor)="data">
                    <div class="text-right">
                        {{ formatCurrency(data.value) }}
                    </div>
                </template>

                <!-- Columna Funcional -->
                <template #cell(funcional)="data">
                    <div class="text-right">
                        {{ data.value || '-' }}
                    </div>
                </template>

                <!-- Columna Alterna -->
                <template #cell(alterna)="data">
                    <div class="text-right">
                        {{ data.value || '-' }}
                    </div>
                </template>

                <!-- Columna Editar -->
                <template #cell(accionEditar)="data">
                    <b-button
                        style="background-color: #FF924C; width: 30px; height: 30px; border: none; border-radius: 4px;"
                        class="md-fab md-primary table-action-btn"
                        @click="editAjuste(data.item.id)"
                        :disabled="readOnly"
                    >
                        <i>
                            <font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" />
                        </i>
                    </b-button>
                </template>

                <!-- Columna Eliminar -->
                <template #cell(accionEliminar)="data">
                    <b-button
                        class="reset-btn-danger table-action-btn"
                        style="width: 30px; height: 30px; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: none; border-radius: 4px;"
                        @click="borraCuentasDestino(data.item.id)"
                        :disabled="readOnly"
                    >
                        <i>
                            <font-awesome-icon :icon="['fas', 'trash']" size="xs" />
                        </i>
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>

        <!-- Modales -->
        <EditAjustesDest
            :showEdiAjustDest="showEdiAjustDest"
            :infoEdit="ajustes"
            :listCuentas="listCuentas"
            :listCuentasSelMul="listCuentasSelMul"
            :idCompania="id_compania"
            :codReporte="codReporte"
            :vigencia="vigencia"
            :secuencia="secuencia"
            :tipo="tipo"
            :tipo_ajuste="tipoAjuste"
            @reloadTblDest="recargaTabla"
            @closeModal="cierraModal"
        />

        <CuentaNuevaDestino
            :showModal="showModalCuentaNueva"
            :idCompania="id_compania"
            :codReporte="codReportePrincipal"
            :vigencia="vigencia"
            :secuencia="secuencia"
            :tipo_ajuste="tipoAjuste"
            :tipo="tipo"
            @closeModal="cierraModalCuentaNueva"
            @cuentaCreada="cuentaCreada"
        />
    </div>
</template>

<script>
import Ajustes from '../../services/AjustesConsol'
import EditAjustesDest from './EditAjustesDest.vue'
import CuentaNuevaDestino from './CuentaNuevaDestino.vue'
import AjustesConsol from '../../services/AjustesConsol'
import PlanCuentas from '../../services/PlanCuentas'
import CorporateDataTable from '../utils/CorporateDataTable.vue'

export default {
    name: "AjustesDestino",

    components: {
        EditAjustesDest,
        CuentaNuevaDestino,
        CorporateDataTable
    },

    props: {
        ajustDestino: {
            type: Array,
            default: () => []
        },

        codReporte: {
            type: [String, Number],
            default: null
        },

        id_compania: {
            type: [String, Number],
            default: null
        },

        vigencia: {
            type: [String, Number],
            default: null
        },

        nombreCompania: {
            type: String,
            default: ''
        },

        readOnly: {
            type: Boolean,
            default: false
        },

        tableLabels: {
            type: Object,
            default: () => ({})
        },

        tableFilterDefs: {
            type: Array,
            default: () => []
        },

        defaultPerPage: {
            type: Number,
            default: 10
        },

        pageOptions: {
            type: Array,
            default: () => [10, 20, 50, 100]
        },

        showBackButton: {
            type: Boolean,
            default: false
        },

        showCompanyName: {
            type: Boolean,
            default: true
        },

        // Nuevas props para pasar desde el padre
        secuencia: {
            type: [String, Number],
            default: null
        },

        tipo: {
            type: [String, Number],
            default: null
        },

        tipoAjuste: {
            type: [String, Number],
            default: null
        }
    },

    data: () => ({
        ajustes: [],
        showEdiAjustDest: false,
        showModalCuentaNueva: false,
        listCuentas: [],
        listCuentasSelMul: [],
        selectedRow: null,
        isLoading: false,
        codReportePrincipal: null,
    }),

    async mounted() {
        this.codReportePrincipal = await this.getReportePrincipal();
    },

    computed: {
        internalLabels() {
            const defaultLabels = {
                titleTbl: "Ajustes Destino",
                cuenta: "Cuenta",
                descripcion: "Descripción",
                valor: "Valor",
                funcional: "Funcional",
                alterna: "Alterna",
                eliminar: "Eliminar",
                editar: "Editar",
                adicionarCuenta: "Adición Cuenta",
                adicionarCuentaNueva: "Adición Cuenta Nueva",
                noData: "No hay cuentas de destino registradas",
                loading: "Cargando...",
                volver: "Volver"
            }

            return {
                ...defaultLabels,
                ...this.tableLabels
            }
        },

        tableFields() {
            return [
                {
                    key: 'cuenta',
                    label: this.internalLabels.cuenta,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-left align-middle',
                    minWidth: '120px'
                },
                {
                    key: 'descripcion',
                    label: this.internalLabels.descripcion,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-left align-middle',
                    minWidth: '200px'
                },
                {
                    key: 'valor',
                    label: this.internalLabels.valor,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-right align-middle',
                    minWidth: '120px'
                },
                {
                    key: 'funcional',
                    label: this.internalLabels.funcional,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-right align-middle',
                    minWidth: '100px'
                },
                {
                    key: 'alterna',
                    label: this.internalLabels.alterna,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-right align-middle',
                    minWidth: '100px'
                },
                {
                    key: 'accionEditar',
                    label: this.internalLabels.editar,
                    thClass: 'text-center',
                    tdClass: 'text-center align-middle',
                    sortable: false,
                    minWidth: '60px'
                },
                {
                    key: 'accionEliminar',
                    label: this.internalLabels.eliminar,
                    thClass: 'text-center',
                    tdClass: 'text-center align-middle',
                    sortable: false,
                    minWidth: '60px'
                }
            ]
        },

        secuenciaActual() {
            return this.secuencia || (this.ajustDestino && this.ajustDestino.length > 0 ? this.ajustDestino[0].secuencia : null)
        },

        tipoActual() {
            return this.tipo || (this.ajustDestino && this.ajustDestino.length > 0 ? this.ajustDestino[0].tipo : null)
        },

        tipoAjusteActual() {
            return this.tipoAjuste || (this.ajustDestino && this.ajustDestino.length > 0 ? this.ajustDestino[0].tipo_ajuste : null)
        }
    },

    methods: {
        goBack() {
            this.$emit('back');
        },

        formatCurrency(value) {
            if (value === 0 || value === "0" || value === null || value === "" || value === undefined) {
                return "";
            }
            return new Intl.NumberFormat('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },

        cierraModal(val) {
            this.showEdiAjustDest = val
        },

        cierraModalCuentaNueva(val) {
            this.showModalCuentaNueva = val
        },

        editAjuste(id) {
            if (this.readOnly) {
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'La vigencia seleccionada está deshabilitada para edición.'
                        : 'The selected validity is disabled for editing.'
                );
                return;
            }

            const itemExistente = this.ajustDestino?.find(item => item.id === id);
            
            if (itemExistente) {
                this.ajustes = { ...itemExistente };
                this.showEdiAjustDest = true;
            } else {
                this.isLoading = true;
                AjustesConsol.consulAjusteDestinoById(id)
                    .then((editAjuste) => {
                        this.ajustes = editAjuste.data.ajuste[0];
                        this.showEdiAjustDest = true;
                    })
                    .catch((error) => {
                        console.error('Error al cargar ajuste:', error);
                        this.$toast.error(
                            this.$store.state._language == "es-ES"
                                ? 'Error al cargar los datos del ajuste'
                                : 'Error loading adjustment data'
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },

        async getReportePrincipal() {
            try {
                const response = await Ajustes.getReportePrincipal();
                return response.data?.codigo;
            } catch (error) {
                console.error('Error al obtener reporte principal:', error);
                return null;
            }
        },

        async borraCuentasDestino(id) {
            if (this.readOnly) {
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'La vigencia seleccionada está deshabilitada para eliminar.'
                        : 'The selected validity is disabled for deleting.'
                );
                return;
            }

            if (!confirm(
                this.$store.state._language == "es-ES"
                    ? '¿Está seguro de que desea eliminar esta cuenta de destino?'
                    : 'Are you sure you want to delete this destination account?'
            )) {
                return;
            }

            this.isLoading = true;

            try {
                const val = {
                    id: this.secuenciaActual,
                    vigencia: this.vigencia,
                    idCompany: this.id_compania,
                }

                await AjustesConsol.borraCuentasDestino(id)

                this.$toast.success(
                    this.$store.state._language == "es-ES"
                        ? 'Cuenta eliminada correctamente'
                        : 'Account deleted successfully'
                );

                await this.recargaTabla(val)
            } catch (error) {
                console.error('Error al eliminar la cuenta:', error);
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'Error al eliminar la cuenta'
                        : 'Error deleting account'
                );
            } finally {
                this.isLoading = false;
            }
        },

        async adicionaCuentasDestino() {
            if (this.readOnly) {
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'La vigencia seleccionada está deshabilitada para crear o editar.'
                        : 'The selected validity is disabled for creating or editing.'
                );
                return;
            }

            if (!this.id_compania) {
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'No se puede identificar la compañía de destino.'
                        : 'Cannot identify the destination company.'
                );
                return;
            }

            try {
                const res = await PlanCuentas.getCuentasPorCompaVigRepor(
                    this.id_compania,
                    this.vigencia,
                    this.codReporte
                )

                this.listCuentas = res.data.planCuentas || []
                this.listCuentasSelMul = res.data.planCuentas || []

                this.ajustes = [
                    {
                        id_compania: this.id_compania,
                        secuencia: this.secuenciaActual,
                        tipo: this.tipoActual,
                        tipo_ajuste: this.tipoAjusteActual
                    }
                ]

                this.showEdiAjustDest = true
            } catch (err) {
                console.error(err)
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'Error al cargar las cuentas'
                        : 'Error loading accounts'
                );
            }
        },

        adicionaCuentaNueva() {
            if (this.readOnly) {
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'La vigencia seleccionada está deshabilitada para crear.'
                        : 'The selected validity is disabled for creating.'
                );
                return;
            }

            if (!this.id_compania) {
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'No se puede identificar la compañía de destino.'
                        : 'Cannot identify the destination company.'
                );
                return;
            }

            this.showModalCuentaNueva = true
        },

        async cuentaCreada() {
            this.showModalCuentaNueva = false
            this.isLoading = true;

            try {
                const val = {
                    id: this.secuenciaActual,
                    vigencia: this.vigencia,
                    idCompany: this.id_compania,
                }

                await this.recargaTabla(val)

                this.$toast.success(
                    this.$store.state._language == "es-ES"
                        ? 'Cuenta creada correctamente'
                        : 'Account created successfully'
                );
            } catch (error) {
                console.error('Error al crear la cuenta:', error);
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'Error al crear la cuenta'
                        : 'Error creating account'
                );
            } finally {
                this.isLoading = false;
            }
        },

        async recargaTabla(val) {
            this.showEdiAjustDest = false
            this.isLoading = true;

            try {
                const codReportePrincipal = await this.getReportePrincipal();

                let ajusteDestino = await AjustesConsol.consulAjusteDestino(
                    val.id,
                    val.vigencia,
                    codReportePrincipal || this.codReporte
                )

                const newData = ajusteDestino.data.ajustDest || []
                this.$emit('update:ajustDestino', newData)
            } catch (error) {
                console.error('Error al recargar la tabla:', error);
                this.$toast.error(
                    this.$store.state._language == "es-ES"
                        ? 'Error al recargar los datos'
                        : 'Error reloading data'
                );
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
.ajustes-detail-container {
    padding: 0;
    width: 100%;
}

.ajustes-detail-table-container {
    width: 100%;
}

.ajustes-detail-table {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.ajustes-detail-table .tblEstandar.tblCorporate {
    min-width: 100% !important;
    width: max-content !important;
    table-layout: fixed !important;
}

.ajustes-detail-table .tblEstandar.tblCorporate td {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 0 !important;
}

.ajustes-detail-table .tblEstandar.tblCorporate thead th {
    white-space: nowrap !important;
}

.detail-toolbar-left {
    flex: 1;
    min-width: 0;
}

.detail-toolbar-left h5 {
    font-size: 0.95rem;
    color: #2c3e50;
}

.detail-toolbar-left .badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.6rem;
}

.detail-toolbar-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 4px;
}

.table-action-btn {
    border: none;
    border-radius: 4px;
    transition: all 0.2s;
}

.table-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.table-toolbar-add-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
}

.table-toolbar-add-btn-dest {
    background-color: #17a2b8;
    color: white;
    border: 1px solid #17a2b8;
}

.table-toolbar-add-btn-dest:hover:not(:disabled) {
    background-color: #138496;
    border-color: #117a8b;
}

.table-toolbar-add-btn-dest:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.table-toolbar-add-btn-dest-new {
    background-color: #007bff;
    color: white;
    border: 1px solid #007bff;
}

.table-toolbar-add-btn-dest-new:hover:not(:disabled) {
    background-color: #0069d9;
    border-color: #0062cc;
}

.table-toolbar-add-btn-dest-new:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.admin-table-block {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.admin-table-block h5 {
    color: #6c757d;
    text-align: center;
    margin: 0;
}

@media (max-width: 768px) {
    .ajustes-detail-container {
        min-height: 450px;
    }

    .ajustes-detail-table-container {
        min-height: 450px;
    }

    .ajustes-detail-table {
        min-height: 450px;
        height: 450px;
    }

    .detail-toolbar-left h5 {
        font-size: 0.8rem;
    }

    .table-toolbar-add-btn-dest,
    .table-toolbar-add-btn-dest-new {
        font-size: 11px;
        padding: 0 10px;
        height: 28px;
        min-height: 28px;
    }
}

@media (max-width: 576px) {
    .ajustes-detail-container {
        min-height: 400px;
    }

    .ajustes-detail-table-container {
        min-height: 400px;
    }

    .ajustes-detail-table {
        min-height: 400px;
        height: 400px;
    }

    .detail-toolbar-left h5 {
        font-size: 0.75rem;
    }

    .detail-toolbar-right {
        flex-wrap: wrap;
        gap: 4px;
    }

    .table-toolbar-add-btn-dest,
    .table-toolbar-add-btn-dest-new {
        font-size: 10px;
        padding: 0 8px;
        height: 26px;
        min-height: 26px;
    }
}
</style>